import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { IconButton } from '@material-ui/core';
import { Clear, ErrorOutline } from '@material-ui/icons';

import { CHROME_DOWNLOAD_URL, EDGE_DOWNLOAD_URL } from '../../../common/constants';

const S = {
  Wrapper: styled.div`
    display: flex;
    padding: 8px 16px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    background-color: #ffe0b2;
  `,
  ErrorOutline: styled(ErrorOutline)`
    margin-right: 0.5rem;
    color: #f57c00;
    font-size: 1.5rem;
  `,
  Paragraph: styled.p`
    margin-right: 2rem;
  `,
  Anchor: styled.a`
    text-decoration: underline;
    :not(:last-child) {
      margin-right: 1rem;
    }
  `,
  IconButton: styled(IconButton)`
    width: 24px;
    height: 24px;
    margin-left: auto;
    padding: 0;
    opacity: 0.34;
  `,
};

const BrowserInstallBanner = ({ onClose }) => (
  <S.Wrapper>
    <S.ErrorOutline />
    <S.Paragraph>
      최적화된 서비스 이용을 위해 새로운 브라우저를 설치하세요.
    </S.Paragraph>
    <S.Anchor
      href={CHROME_DOWNLOAD_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      Chrome 다운로드
    </S.Anchor>
    <S.Anchor
      href={EDGE_DOWNLOAD_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      Microsoft Edge 다운로드
    </S.Anchor>
    <S.IconButton type="button" onClick={onClose}>
      <Clear />
    </S.IconButton>
  </S.Wrapper>
);

BrowserInstallBanner.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default BrowserInstallBanner;
